import { useState } from "react";
import useSalesTransactionsTable from "./useSalesTransactionsTable";
import secondaryComponents from "..";
import primaryComponents from "../../primaryComponents";
import Orderflows from "../StoreCheckout/Orderflows";
import { ReturnIcon } from "../../../assets/svgIcons";

const SalesTransactionsTable = ({
  metaDetails,
  salesTransactions,
  handleFetchSalesTransactions,
  gotoPage,
  showpricing = true,
  selectedTab,
  isViaSellMode = false,
}) => {
  const { instance, selectedOrder, setSelectedOrder } =
    useSalesTransactionsTable({
      salesTransactions,
      handleRefetchOrders: handleFetchSalesTransactions,
      showpricing,
      selectedTab,
      isViaSellMode,
    });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;
  const [isReturnStock, setIsReturnStock] = useState(false);

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <h4 className="py-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {salesTransactions?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={selectedOrder !== null}
        closeModal={() => setSelectedOrder(null)}
        width={1300}
        padding={0}
        style={{ maxHeight: "100%", height: "100vh", borderRadius: "0" }}
      >
        <Orderflows
          closeModal={() => setSelectedOrder(null)}
          orderId={selectedOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={true}
          headerExtra={
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_return_products"
            >
              <primaryComponents.Button
                classNames={"btn btn--orange smallBtn"}
                onClick={() => setIsReturnStock(true)}
                style={{ padding: "0 10px" }}
              >
                <ReturnIcon width="18" height="18" />
                <span className="ml-1">Return</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          }
        />
      </secondaryComponents.Modal>

      {/* return widget */}
      <secondaryComponents.SideModal
        width={700}
        isActive={isReturnStock}
        closeModal={() => setIsReturnStock(false)}
      >
        <secondaryComponents.ReturnStockWidget
          closeWidget={() => setIsReturnStock(false)}
          defaultOrderId={selectedOrder}
        />
      </secondaryComponents.SideModal>
    </>
  );
};

export default SalesTransactionsTable;
